// extracted by mini-css-extract-plugin
export default {"box":"Home_box__FvYh+","backgroundImage":"Home_backgroundImage__-skaz","slogan":"Home_slogan__iC1de","noWrap":"Home_noWrap__nVQZZ"};